import { Environment } from './environment.config'

export const environment: Environment = {
  name: 'development',
  identityApiBaseUrl: 'https://dev.gamesans.net/api/identity',
  gameSetupSiteBaseUrl: 'https://dev.gamesans.net',
  gamePlayApiBaseUrl: 'https://dev.gamesans.net/api/game-play',
  getGamePlayPollTimeoutInMilliseconds: 3000,
  dealingCardsPollTimeoutInMilliseconds: 2000,
  completedGamePollTimeoutInMilliseconds: 2000,
}
